import { change } from 'redux-form';
import get from 'lodash/get';

export const updateCurrencies = (dispatch, getState, country) => {
  if (get(country, 'iso_alpha2') !== 'US') disableGeotix(dispatch, getState);

  if (!country) return;

  const state = getState();
  const currencies = state.currencies;
  const formCurrency = get(state, 'form.eventSubmission.values.currency', null);
  const openHouseCurrency = get(state, 'form.eventSubmission.values.open_house.currency.value', null);
  const prices = get(state, 'form.eventSubmission.values.prices', []);

  const defaultCurrency = get(country, 'default_currency', 'USD');
  const newCurrency = currencies.find((e) => e.value == defaultCurrency);

  formCurrency !== newCurrency && dispatch(change('eventSubmission', 'currency', newCurrency));
  openHouseCurrency !== newCurrency && dispatch(change('eventSubmission', 'open_house.currency', newCurrency));

  prices.forEach((price, idx) => {
    get(price, 'currency.value') !== newCurrency &&
      dispatch(change('eventSubmission', `prices[${idx}].currency`, newCurrency));
  });
};

export const updateCountryDependencies = (country) => (dispatch, getState) => {
  updateCurrencies(dispatch, getState, country);
};

export const updateZip = (dispatch, getState, zipCode) => {
  if (zipCode) return;
  disableGeotix(dispatch, getState);
};

export const disableGeotix = (dispatch, getState) => {
  const formUrlType = get(getState(), 'form.eventSubmission.values.ticketing_url_type');
  formUrlType === 'geotix' && dispatch(change('eventSubmission', 'ticketing_url_type', 'own_url'));
};

export const updateZipDependencies = ({ target }) => (dispatch, getState) => {
  updateZip(dispatch, getState, target.value);
};



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/actions/formActions.js